import { resetAppData, fetchAppData }      from './../classes/HandleGeo';
import cookie                              from 'react-cookie';
import { allowGeoChange, triggerRequired } from './../classes/GeoThrottle';

/**
 * GEO_RESOLVED is important to the app start up only.  GEO enabled may be stored
 * in a cookie and so the app needs to know if it should wait before fetching places.
 *
 * GEO_RESOLVED is true when we know if
 *
 * The app should be watching on startup and the geo data has been stored.
 * Geo location is not available on app  start up.
 * Geo location is disabled on app start up.
 * The app should not be watching on start up.
 *
 * After the value is set, it should not be reset.  GEO location state can change later.
 */

export const GEO_AVAILABLE     = 'GEO_AVAILABLE';
export const GEO_UNAVAILABLE   = 'GEO_UNAVAILABLE';
export const GEO_ENABLED       = 'GEO_ENABLED';
export const GEO_DENIED        = 'GEO_DENIED';
export const GEO_INIT          = 'GEO_INIT';
export const GEO_STOP_WATCHING = 'GEO_STOP_WATCHING';
export const GEO_STORED        = 'GEO_STORED';
export const GEO_WAITING       = 'GEO_WAITING';
export const GEO_RESOLVED      = 'GEO_RESOLVED';

// The user hsa been informed there is an error
export const GEO_INFORMED       = 'GEO_INFORMED';
export const GEO_RESET_INFORMED = 'RESET_GEO_INFORMED';

const GEO_ON  = 'on';
const GEO_OFF = 'off';

const saveGeoOn = () =>
{
    cookie.save('geo', GEO_ON, { path: '/', httpOnly: false });
};

const saveGeoOff = () =>
{
    cookie.save('geo', GEO_OFF, { path: '/', httpOnly: false });
};

const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
};

export const geoInformed = () =>
{
    return { type: GEO_INFORMED };
};

export const geoResetInformed = () =>
{
    return { type: GEO_RESET_INFORMED };
};

export const geoStored = (coords, watchingId) => {
    return {
        type      : GEO_STORED,
        watchingId: watchingId,
        coords    : coords
    }
};

/**
 * Clear the watcher
 * Dispatch the stop watching action
 * Dispatch the Closest reset closest action
 *
 * @returns {function()}
 */
export const stopWatching = () =>
{
    return (dispatch, getState) =>
    {
        saveGeoOff();
        resetAppData(dispatch, getState);
        navigator.geolocation.clearWatch(getState().geo.watchingId);
        dispatch({ type: GEO_STOP_WATCHING });
    };
};

/**
 * If the initial geo state is resolved, this is called by a change in GEO data and so
 * the app place data should be reset before being fetched again.
 */
const handleGeoWatchSuccess = (pos, dispatch, getState) =>
{
    let store, trigger;
    
    if (null !== getState().geo.coords)
    {
        store = allowGeoChange(getState().geo.coords, pos.coords);

        /**
         * Test the position against the coords of the current closest place, if we are within
         * trigger distance, reset the app data and fetch new data regardless of the result of
         * allowGeoChange.
         *
         * IMPORTANT to note that new closest data will be fetched and so the closest place triggered
         * might not the one current at this point of execution.
         *
         */
        if (null !== getState().closest.item && false === getState().closest.triggered)
        {
            trigger = triggerRequired(pos.coords, getState().closest.item);
        }

        if (store || trigger)
        {
            resetAppData(dispatch, getState);
        }
    }
    else
    {
        saveGeoOn();
        store = true;
    }

    if (store || trigger)
    {
        dispatch({
            type      : GEO_STORED,
            coords    : pos.coords
        });

        fetchAppData(dispatch, getState);
    }
};

/**
 * If the initial geo state is resolved, this is called by a change in GEO data and so
 * the app place data should be reset before being fetched again.
 */
const handleGeoWatchError = (error, dispatch, getState) =>
{
    saveGeoOff();
    if (getState().geo.resolved)
    {
        resetAppData(dispatch, getState);
    }

    if (error.code === error.PERMISSION_DENIED)
    {
        dispatch({ type: GEO_DENIED });
    }
    else
    {
        dispatch({ type: GEO_UNAVAILABLE });
    }

    fetchAppData(dispatch, getState);
};

/**
 * Call GeoLocation.watchPosition and dispatch the geoStored action with the
 * fetched coordinates.
 *
 * Dispatch the geoWatching action with the watch id.
 *
 * @returns {function()}
 */
export const startWatching = () =>
{
    return (dispatch, getState) =>
    {
        saveGeoOn();
        dispatch({ type   : GEO_WAITING });

        const watchingId = navigator.geolocation.watchPosition(
            pos =>
            {
                return handleGeoWatchSuccess(pos, dispatch, getState);
            },
            error =>
            {
                return handleGeoWatchError(error, dispatch, getState)
            },
            options
        );

        dispatch({
            type      : GEO_INIT,
            watchingId: watchingId
        });
    };
};

export const checkAvailable = () =>
{
    return dispatch =>
    {
        if (navigator.geolocation)
        {
            dispatch({ type: GEO_AVAILABLE });
        }
        else
        {
            dispatch({ type: GEO_UNAVAILABLE });
        }
    }
};

/**
 * Check GEO location is available.
 * If yes, check the cookie to see if the app should be watching GEO location.
 * If yes, start watching.
 * If no, resolve the GEO location state.
 **/
export const initGeo = () =>
{
  return (dispatch, getState) =>
  {
      dispatch(checkAvailable());
      if (getState().geo.available)
      {
          let isWatching = cookie.load('geo');

          if (GEO_ON === isWatching)
          {
              dispatch(startWatching());
          }
          else
          {
              dispatch({ type: GEO_RESOLVED });
          }
      }
  }
};


// WEBPACK FOOTER //
// ./src/actions/GeoLocationAction.js